import './bootstrap';

const redirectToLoginIfSessionExpired = (status) => {
    if (status !== 419) {
        return false;
    }

    const loginUrl = document.querySelector('meta[name="login-url"]')?.content;

    if (loginUrl) {
        window.location.assign(loginUrl);
    }

    return true;
};

window.axios.interceptors.response.use(
    (response) => response,
    (error) => {
        redirectToLoginIfSessionExpired(error.response?.status);

        return Promise.reject(error);
    },
);

document.addEventListener('livewire:init', () => {
    Livewire.hook('request', ({ fail }) => {
        fail(({ status, preventDefault }) => {
            if (redirectToLoginIfSessionExpired(status)) {
                preventDefault();
            }
        });
    });
});
